import { render, staticRenderFns } from "./UnusuallyHighExpensesFS.vue?vue&type=template&id=7efd0ec2"
import script from "./UnusuallyHighExpensesFS.vue?vue&type=script&lang=ts"
export * from "./UnusuallyHighExpensesFS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports